var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Gesture } from "./Gesture";
import { Vector3 } from "flavr-math";
import { localPlayerContainer } from "../localplayer/LocalPlayerContainer";
import { GestureType, MoveGestureMessage, convertToNumber3 } from "flavr-common";
import { preferencesService } from "../preferences/PreferencesService";
const tmpPosition = new Vector3();
const tmpOrigin = new Vector3();
const tmpMax = new Vector3();
const MOVE_SPEED = 3;
const MOVE_MIN = new Vector3(-1000, -100, -1000);
const MOVE_MAX = new Vector3(+1000, +100, +1000);
export class GrabMoveGesture extends Gesture {
    constructor(changeHeight, gestureModule) {
        super(changeHeight ? GestureType.GrabMove3D : GestureType.GrabMove2D, true);
        this.changeHeight = changeHeight;
        this.gestureModule = gestureModule;
        this.movementSensitivityVR = 1;
        this.movementSensitivityVR = preferencesService.getNumberPreferredValue("movementSensitivityVR", 1);
        preferencesService.onPreferenceChanged.add((key, newValue) => __awaiter(this, void 0, void 0, function* () {
            if (key !== "movementSensitivityVR")
                return false;
            this.movementSensitivityVR = parseFloat(newValue);
            return true;
        }));
    }
    begin() { }
    update(messages) {
        const prevData = this.gestureModule.prevData;
        const data = this.gestureModule.currData;
        if (!prevData.primaryPos || data.primaryController !== prevData.primaryController || this.movementSensitivityVR === undefined)
            return;
        if (data.primaryController) {
            const diff = tmpPosition.subVectors(data.primaryController.position, prevData.primaryPos);
            diff.multiplyScalar(MOVE_SPEED * this.movementSensitivityVR);
            if (!this.changeHeight) {
                diff.y = 0;
            }
            this.moveWorldCenter(diff);
            messages.push(new MoveGestureMessage(convertToNumber3(diff)));
        }
    }
    end() { }
    moveWorldCenter(diff) {
        localPlayerContainer.transformDirectionFromPlatformToWorldCoordinates(diff);
        const platformPos = localPlayerContainer.getPosition(tmpOrigin);
        this.setWorldCenter(diff.subVectors(platformPos, diff));
    }
    setWorldCenter(newPlatformPos) {
        const min = tmpOrigin.copy(MOVE_MIN);
        const max = tmpMax.copy(MOVE_MAX);
        const clampedPos = tmpPosition.copy(newPlatformPos).clamp(min, max);
        localPlayerContainer.movePlatform(clampedPos.sub(localPlayerContainer.getPosition(tmpOrigin)));
    }
}
